import classNames from "classnames";
import React, { ReactNode } from "react";
import styles from "./DisplayFrame.scss";

export const DisplayFrame = ({
    children,
    aspect,
    onClick,
    active
}: {
    children: ReactNode;
    aspect: "16:9" | "1:1";
    onClick: () => void;
    active: boolean;
}) => {
    return React.createElement(
        onClick !== null ? "button" : "div",
        {
            onClick,
            className: classNames(styles.base, {
                [styles["aspect-16-9"]]: aspect === "16:9",
                [styles["aspect-1-1"]]: aspect === "1:1",
                [styles.clickable]: onClick,
                [styles.active]: active
            })
        },
        <div className={styles.wrapper}>{children}</div>
    );
};

DisplayFrame.defaultProps = {
    aspect: "16:9",
    onClick: null
};
